__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "tm-container";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@auth0/auth0-react", "2.1.0", () => (__webpack_require__.e(100).then(() => (() => (__webpack_require__(8100))))));
			register("@tanstack/react-query", "4.36.1", () => (__webpack_require__.e(941).then(() => (() => (__webpack_require__(7941))))));
			register("@vgh-code/vjui", "2.58.0", () => (Promise.all([__webpack_require__.e(225), __webpack_require__.e(773), __webpack_require__.e(525)]).then(() => (() => (__webpack_require__(9225))))));
			register("jwt-decode", "3.1.2", () => (__webpack_require__.e(245).then(() => (() => (__webpack_require__(6245))))));
			register("keycloak-js", "20.0.5", () => (__webpack_require__.e(671).then(() => (() => (__webpack_require__(4671))))));
			register("react-dom", "18.2.0", () => (() => (__webpack_require__(3935))), 1);
			register("react-router-dom", "6.11.2", () => (__webpack_require__.e(818).then(() => (() => (__webpack_require__(9818))))));
			register("react-use-websocket", "4.3.1", () => (Promise.all([__webpack_require__.e(676), __webpack_require__.e(773)]).then(() => (() => (__webpack_require__(7676))))));
			register("react", "18.2.0", () => (() => (__webpack_require__(7294))), 1);
			initExternal(5682);
			initExternal(1118);
			initExternal(3737);
			initExternal(4833);
			initExternal(5062);
			initExternal(234);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};